import { ajaxor2 } from '../common/basic';

import getNLS from '../common/_NLS';

// pan2HNBTools

/**
 * 로그인시패스워드변경: 폴백3
 * 회원가입: 폴백2 너무커서 어쩔수  없다.
 * 회원가입완료: 폴백3
 * 로그인: 폴백2 매뉴얼하게 맞춤
 ******************* 패스워드초기화: 폴백1을 자체내장. 폴백3을 자체내장하게 바꿔야됨.
 */

import React, { Component, useState, useEffect } from 'react';
import Link from 'next/link';

import defaultStates from '../../src-component/defaultStates';

import FallbackModal from '../popup/Fallback';
import Login from '../popup/member/Login';
import FallbackModal2 from '../popup/Fallback2';
import FallbackModal3 from '../popup/Fallback3';

import Binder from '../popup/search/Binder';
import LangBinder from '../popup/language/LanguageBinder';

import NotificationBinder from "../popup/notification/Binder";

import ResetPassword from '../popup/member/ResetPassword2';
import Join from '../popup/member/Join';
import JoinComplete from '../popup/member/JoinComplete';
import ChangePasswordOnLogin from '../popup/member/ChangePasswordOnLogin';


export default props=>{
  // if (!props.me) return <></>;
  const [dLogin, setLogin] = useState('none');
  const [dResetPassword, setResetPassword] = useState('none');
  const [dJoin, setJoin] = useState('none');
  const [dJoinComplete, setJoinComplete] = useState('none');
  const [dChangePasswordOnLogin, setChangePasswordOnLogin] = useState('none');
  
  const [vMyInfo, setMyInfo] = useState({user:'초기값'});
  const [vIsLogon, setIslogin] = useState(false);
  
  // vIsLogon =setIslogin;
  
  if (process.browser) setSolid("pan2 HNBTOOLS "
  + dLogin 
  + dResetPassword 
  + dJoin 
  + dJoinComplete 
  + dChangePasswordOnLogin 
  );
  
  useEffect(()=>{
    if (defaultStates.isLogon()) fillLoginer();;
    setIslogin(defaultStates.isLogon());
  },[vIsLogon]);
  
  useEffect(() => {
    if (!process.browser) return;
    fillLoginer();

    return ()=>{};
    
  }, []);

  function fillLoginer(){
    ajaxor2({
      url: "/user/get",
      callback: callback,
    });

    function callback(r) {
      if (r == undefined) return localStorage.removeItem('loginer');

      if (r.user.profile_picture.length > 0) {
        r.user.profile_picture[0].archived_url =
          r.user.profile_picture[0].archived_url.split("http://localhost:8000").join("https://api.camscon.kr");
      }

      setMyInfo(r.user); // 이변수

      localStorage['loginer'] = JSON.stringify(r.user); // 브라우저 로컬스토리지
    }

  }
  
  
  const jsx = (<div className="pan2" >

{/* 테스트 */}
{/* <a onClick={() => {
// setLogin('block');
// setResetPassword('block');
// setJoin('block');
// setJoinComplete('block');
setChangePasswordOnLogin('block');
      // getList();
    
}} >TTTTTEEEEEEESSSSSSSSSTTTTTTTT</a> */}

<style jsx>{`
  * {
    box-sizing: border-box;
    margin:0;
    border:0;
    padding:0;
  }


.search-input {
  background-color: #f5f5f5;
  -o-border-radius: 4px;
  -ms-border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  width: 550px;
  height: 40px;
  padding: 6px 12px;

  background-image: url('/assets/images/ico-search.svg');
  background-repeat: no-repeat;
  background-position: left;
  background-position-x: 10px;
  text-indent: 20px;

  font-size:16px;

}

.word .highlighted{
  font-weight: bold;
  color: #343a40;
}



.leftp{
  position: absolute;
  top: 16px;
  left: 0px;

  font-family: NotoSansCJKkr;
  font-size: 12px;
  line-height: 1;
}


.display-inline{
  display: inline;
  margin: 0;
  vertical-align: middle;
}

.di-vertical-middle{
  display: inline;
  vertical-align: middle;
}


.current{}
.total{}

.pan2 {
  width: 100%;
  height: 70px;
  margin: 0 auto;
  position: relative;

}

.text1 {
  font-family: NotoSansCJKkr;
  font-size: 16px;
  line-height: 1;

  text-align: center;
  padding: 14px 0 0 0;
  color: #868e96;
}

.text1 p{
}

.text1 p span{
}

.word{
  vertical-align: middle;

  font-weight: bold;
  color: #adb5bd;

    margin: 0 30px 0 0;
    padding-top: 10px;
    display: inline-block;
    vertical-align: top;
}


.rightp{
  position: absolute;
  top: 18px;
  right: 0;

  font-family: NotoSansCJKkr;
  font-size: 12px;
  line-height: 1;

  /* width: 214px; */
}

.korean{
  margin: 0 8px;
}


.m24-8{
  /* margin: 0 16px 0 24px; */
  margin: 0 10px 0 24px;
}

.super-menu{
  color: #adb5bd;
  vertical-align: top;
  /* vertical-align: middle; */
}

.plus{
  margin: 0 24px 0 30px;
  vertical-align: top;
}

.plus img{
  padding-top: 5px;
  vertical-align: top;
  /* transform: translate(0px, 5px); */

}

.noti-frame{
  vertical-align:top;
  /* vertical-align: middle; */
  /* vertical-align: text-top; */
}

.noti-frame img{
  padding-top: 5px;
}

@media all and (max-width:606px) {
  .pan2 {
    height: 50px;
  }

  .text1{
    padding: 0;
  }
  .search-input{
    min-width: 245px;
    width: 70%;
  }

  .m24-8{
    margin: 0;
  }

  .rightp{
    top: 3px;
    right: -4px;
  }

}



`}</style>

    <div className="leftp dnom" >
      <div className="display-inline" >
        <a href="/">
          <img alt="logo" src="/assets/images/logo-camscon.svg" />
        </a>
      </div>
    </div>

    <div className="text1" >

      <a className=" dnom word" href="/magazine/list">
        <div className={"aa display-inline super-menu " + (props.isMagazine ? "highlighted" : "")} >{getNLS("매거진")}</div>
      </a>
      
      <a className=" dnom word" href="/community/list">
        <div className={"display-inline super-menu " + (props.isCommunity ? "highlighted" : "")} >{getNLS("커뮤니티")}</div>
      </a>

      {/* 검색입력바 */}
      <div className="display-inline inputbound" >
        <Binder showMenu={props.showMenu} isCommunity={props.isCommunity} />
      </div>
        {/* // 기존: (props.isCommunity)?  */}
      <a className="super-menu" href={"/" 
        + ( (vMyInfo.is_inspirer || vMyInfo.is_admin)        
        ? "magazine/posting/upload1" : "community/upload1" )
      }>
        <div className="display-inline dnom plus" >
          <img src="/assets/images2/group-20@2x.png" />
        </div>
      </a>

      <div className="display-inline inputbound noti-frame" >
        <NotificationBinder />
      </div>

      <div className="display-inline" ></div>
      <div className="display-inline" ></div>
    </div>
    <div className="rightp" >
      <div className="dib dnom" >
        <LangBinder />
        </div>
      <div className="display-inline" >
        {vIsLogon?
          <a href={"/mypage/Blog"} >
            <div className="di-vertical-middle m24-8">
              <img className="di-vertical-middle round-psa" 
                // src="/assets/images/ico-empty.svg" // 디폴트, empty
                // src={ vMyInfo.user.profile_picture && vMyInfo.user.profile_picture[0].optimized_url}
                src={vMyInfo.profile_picture && vMyInfo.profile_picture[0] != undefined ? vMyInfo.profile_picture[0].archived_url :"/assets/images/ico-empty.svg"} 
                onError={e => {
                  console.log("onError: no PSA");
                  e.target.src = "/assets/images/ico-empty.svg";
                }} 
              />
            </div>
            <div className="somebark display-inline dnom">{!vMyInfo?'': vMyInfo.username}</div>
          </a>
        :
          <a onClick={() => setLogin('block')} >
            <div className="di-vertical-middle m24-8">
              <img src="/assets/images/ico-empty.svg" />
            </div>
          </a>
        }
        <FallbackModal2 display={dLogin} 
          hide={() => setLogin('none')} 
          innerContent={<Login display={dLogin} 
            hide={() => { setLogin('none') }}
            setResetPassword={() => {
              setLogin('none');
              setResetPassword('block');
            }}

            setJoin={() => {
              setLogin('none');
              setJoin('block');
            }}

          />}
        />

        <ResetPassword display={dResetPassword} 
          hide={() => setResetPassword('none')} 
          setLogin={() => {
            setResetPassword('none');
            setLogin('block');
          }} 
        />
        {/* <FallbackModal3 display={dResetPassword}
          hide={() => setResetPassword('none')}
          innerContent={
            <ResetPassword display={dResetPassword} hide={() => setResetPassword('none')} />
            }
        /> */}

        <FallbackModal2 display={dJoin} 
          hide={() => { setJoin('none') }}
          innerContent={<Join display={dJoin} 
          hide={() => setJoin('none')} 
          setJoinComplete={() => {
            setJoin('none');
            setJoinComplete('block');
          }}
          setLogin={() => {
            setJoin('none');
            setLogin('block');
          }}

          />}
        />

        <FallbackModal3 display={dJoinComplete} hide={() => { setJoinComplete('none') }}
          innerContent={<JoinComplete display={dJoinComplete} hide={() => setJoinComplete('none')} />}
        />

        <FallbackModal3 display={dChangePasswordOnLogin} hide={() => { setChangePasswordOnLogin('none') }}
          innerContent={<ChangePasswordOnLogin display={dChangePasswordOnLogin} hide={() => setChangePasswordOnLogin('none')} />}
        />

      </div>

    </div>

  </div>);

  return (jsx);
}
